import { render, staticRenderFns } from "./yearly-report.vue?vue&type=template&id=4dd467d8&"
import script from "./yearly-report.vue?vue&type=script&lang=js&"
export * from "./yearly-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports